// Helper function to dispatch a change event
const dispatchChangeEvent = (element) => {
    if (element) {
        element.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

// Compatibility shim for mixed selectWoo/select2 stacks used by shipping plugins.
// In some flows (observed on NP Kyiv scenarios), select2 container may miss
// focusOnActiveElement(), which throws and breaks further checkout JS.
if (window.jQuery) {
    window.jQuery(document).on('select2:opening select2:closing', 'select', function () {
        const inst = window.jQuery(this).data('select2');
        if (inst && inst.container && typeof inst.container.focusOnActiveElement !== 'function') {
            inst.container.focusOnActiveElement = function () { };
        }
    });
}

// Helper function to find and set a select option by its text content
function setSelectOptionByText(selectElement, text) {
    if (!selectElement || !text) {
        return;
    }

    // Handle cases where the element is not a select dropdown
    if (selectElement.tagName !== 'SELECT') {
        selectElement.value = text;
        return;
    }

    const options = Array.from(selectElement.options);
    // Try to find an option that starts with the text, e.g., "Київська" should match "Київська область"
    const targetOption = options.find(option => option.text.trim().startsWith(text));

    if (targetOption) {
        selectElement.value = targetOption.value;
    } else {
        // Fallback for cases where the value might be the text itself or if no match is found
        selectElement.value = text;
    }
}

// Function to parse address string
function parseAddress(addressString) {
    const parsed = {
        postcode: '02000',
        state: 'UA30',
        city: 'unknown',
        address1: 'unknown'
    };

    if (!addressString) {
        return parsed;
    }

    const parts = addressString.split(',').map(p => p.trim()).filter(p => p.length > 0);

    // Attempt to find postcode (5 digits) - usually the first part
    if (parts.length > 0 && /^\d{5}$/.test(parts[0])) {
        parsed.postcode = parts[0];
        parts.shift(); // Remove postcode from parts
    }

    // Attempt to find state (обл. or область)
    const stateRegex = /^(обл\.|область)\s*([^\,]+)/i;
    const stateIndex = parts.findIndex(p => stateRegex.test(p));
    if (stateIndex !== -1) {
        const match = parts[stateIndex].match(stateRegex);
        if (match && match[2]) {
            parsed.state = match[2].trim();
        }
        parts.splice(stateIndex, 1); // Remove state from parts
    }

    // Attempt to find city (м. or місто)
    const cityRegex = /^(м\.|місто)\s*([^\,]+)/i; // Changed regex to stop at comma
    const cityIndex = parts.findIndex(p => cityRegex.test(p));
    if (cityIndex !== -1) {
        const match = parts[cityIndex].match(cityRegex);
        if (match && match[2]) {
            parsed.city = match[2].trim();
        }
        parts.splice(cityIndex, 1); // Remove city from parts
    }

    // The rest is address1
    parsed.address1 = parts.join(', ').trim();

    // console.info(parsed);
    return parsed;
}

document.addEventListener('DOMContentLoaded', () => {
    // Function to load user data
    function _load_user_data() {
        const formData = new FormData();
        formData.append('action', 'kitan_user_data');
        formData.append('nonce', main.nonce);

        return fetch(main.ajaxUrl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.data.user_data) {
                    const { companies, saved } = data.data.user_data;
                    window.kpCheckoutCompanies = companies;
                    const legalEntitySelect = document.getElementById('legal_entity');
                    const contractSelect = document.getElementById('contract');
                    const selectedAddressSelect = document.getElementById('selected_address');

                    if (!legalEntitySelect || !contractSelect) {
                        console.warn('Селекты для юр. лица и договора не найдены на странице.');
                        return;
                    }

                    const populateContracts = (companyId) => {
                        const selectedCompany = companies.find(c => c.id == companyId);
                        contractSelect.innerHTML = '';

                        const defaultContractOption = document.createElement('option');
                        defaultContractOption.value = '';
                        defaultContractOption.textContent = 'Оберіть договір';
                        contractSelect.appendChild(defaultContractOption);

                        if (selectedCompany && Array.isArray(selectedCompany.contracts)) {
                            selectedCompany.contracts.forEach(file => {
                                const option = document.createElement('option');
                                option.value = file['contract-number'];
                                option.textContent = file['type-contract'];
                                contractSelect.appendChild(option);
                                dispatchChangeEvent(option); // Dispatch change for each new option
                            });
                        }
                    };

                    const populateAddresses = (companyId) => {
                        if (!selectedAddressSelect) return;

                        const selectedCompany = companies.find(c => c.id == companyId);
                        selectedAddressSelect.innerHTML = '';

                        const defaultAddressOption = document.createElement('option');
                        defaultAddressOption.value = '';
                        defaultAddressOption.textContent = 'Оберіть адресу';
                        selectedAddressSelect.appendChild(defaultAddressOption);

                        if (selectedCompany && Array.isArray(selectedCompany.addresses)) {
                            selectedCompany.addresses.forEach(address => {
                                const option = document.createElement('option');
                                option.value = address;
                                option.textContent = address;
                                selectedAddressSelect.appendChild(option);
                                dispatchChangeEvent(option);
                            });
                        }
                    };

                    const populateBillingFields = (companyId) => {
                        const selectedCompany = companies.find(c => c.id == companyId);

                        const firstNameInput = document.getElementById('billing_first_name');
                        const lastNameInput = document.getElementById('billing_last_name');
                        const companyInput = document.getElementById('billing_company');
                        const address1Input = document.getElementById('billing_address_1');
                        const phoneInput = document.getElementById('billing_phone');
                        const user_phone = document.getElementById('user_phone');
                        const user_name = document.getElementById('user_name');

                        const billingCityInput = document.getElementById('billing_city');
                        const billingStateInput = document.getElementById('billing_state');
                        const billingPostcodeInput = document.getElementById('billing_postcode');
                        const user_address = document.getElementById('user_address');

                        if (selectedCompany) {
                            const [firstName, ...lastNameParts] = (selectedCompany.person || '').split(' ');
                            const lastName = lastNameParts.join(' ');

                            if (firstNameInput) { firstNameInput.value = firstName || ''; dispatchChangeEvent(firstNameInput); }
                            if (lastNameInput) { lastNameInput.value = lastName || ''; dispatchChangeEvent(lastNameInput); }
                            if (user_name) { user_name.value = selectedCompany.person; dispatchChangeEvent(user_name); }
                            if (phoneInput) { phoneInput.value = selectedCompany.phone || ''; dispatchChangeEvent(phoneInput); }
                            if (user_phone) { user_phone.value = selectedCompany.phone || ''; dispatchChangeEvent(user_phone); }
                            if (companyInput) { companyInput.value = selectedCompany.title || ''; dispatchChangeEvent(companyInput); }
                            // The original address was assigned to address1Input and user_address,
                            // but now we want to parse it and assign to individual fields.
                            // user_address should also be updated by the parsed address.
                            // if (address1Input) address1Input.value = selectedCompany.address || ''; // This line should be removed or modified
                            if (user_address) { user_address.value = selectedCompany.address || ''; dispatchChangeEvent(user_address); }

                            // Parse and populate address fields
                            const parsedAddress = parseAddress(selectedCompany.address || '');

                            if (address1Input) { address1Input.value = parsedAddress.address1; dispatchChangeEvent(address1Input); }
                            if (billingCityInput) { billingCityInput.value = parsedAddress.city; dispatchChangeEvent(billingCityInput); }
                            if (billingStateInput) {
                                setSelectOptionByText(billingStateInput, parsedAddress.state);
                                dispatchChangeEvent(billingStateInput);
                            }
                            if (billingPostcodeInput) { billingPostcodeInput.value = parsedAddress.postcode; dispatchChangeEvent(billingPostcodeInput); }
                            if (document.getElementById('billing_country')) document.getElementById('billing_country').value = 'UA'; // Always set to Ukraine
                            dispatchChangeEvent(document.getElementById('billing_country'));

                        } else {
                            // Очищаем поля, если юр. лицо не выбрано
                            if (firstNameInput) firstNameInput.value = '';
                            if (lastNameInput) lastNameInput.value = '';
                            if (phoneInput) phoneInput.value = '';
                            if (companyInput) companyInput.value = '';
                            if (user_phone) user_phone.value = '';
                            if (user_name) user_name.value = '';
                            if (user_address) user_address.value = '';
                            if (address1Input) address1Input.value = '';
                            dispatchChangeEvent(firstNameInput);
                            dispatchChangeEvent(lastNameInput);
                            dispatchChangeEvent(phoneInput);
                            dispatchChangeEvent(companyInput);
                            if (billingCityInput) billingCityInput.value = '';
                            if (billingStateInput) billingStateInput.value = '';
                            if (billingPostcodeInput) billingPostcodeInput.value = '';
                        }
                    };

                    legalEntitySelect.innerHTML = '';
                    const defaultCompanyOption = document.createElement('option');
                    defaultCompanyOption.value = '';
                    defaultCompanyOption.textContent = 'Оберіть юридичну особу';
                    legalEntitySelect.appendChild(defaultCompanyOption);

                    companies.forEach(company => {
                        const option = document.createElement('option');
                        option.value = company.id;
                        option.textContent = company.title;
                        legalEntitySelect.appendChild(option);
                    });

                    if (saved && saved.company_id) {
                        legalEntitySelect.value = saved.company_id;
                        populateContracts(saved.company_id);
                        populateAddresses(saved.company_id);
                        populateBillingFields(saved.company_id);
                        if (saved.contract_id) {
                            setTimeout(() => {
                                contractSelect.value = saved.contract_id;
                            }, 0);
                        }
                    }

                    // Dispatch change events for initial load
                    // Initial dispatching of change events is now handled by populateBillingFields and populateContracts

                    legalEntitySelect.addEventListener('change', (e) => {
                        populateContracts(e.target.value);
                        populateAddresses(e.target.value);
                        populateBillingFields(e.target.value);
                    });

                    if (selectedAddressSelect) {
                        selectedAddressSelect.addEventListener('change', (e) => {
                            const address = e.target.value;
                            const userAddressInput = document.getElementById('user_address');

                            if (userAddressInput) {
                                if (address) {
                                    userAddressInput.value = address;
                                } else {
                                    const companyId = legalEntitySelect.value;
                                    const selectedCompany = companies.find(c => c.id == companyId);
                                    if (selectedCompany) {
                                        userAddressInput.value = selectedCompany.address || '';
                                    }
                                }
                                userAddressInput.dispatchEvent(new Event('input'));
                            }
                        });
                    }

                    // Event listener for user_address input changes
                    const userAddressInput = document.getElementById('user_address');
                    if (userAddressInput) {
                        userAddressInput.addEventListener('input', (e) => {
                            const newAddress = e.target.value;
                            const parsedAddress = parseAddress(newAddress);
                            updateBillingAddressFields(parsedAddress);
                        });
                    }

                    // Event listener for user_name input changes
                    const userNameInput = document.getElementById('user_name');
                    if (userNameInput) {
                        userNameInput.addEventListener('input', (e) => {
                            const fullName = e.target.value || '';
                            const [firstName, ...lastNameParts] = fullName.split(' ');
                            const lastName = lastNameParts.join(' ');

                            const billingFirstNameInput = document.getElementById('billing_first_name');
                            const billingLastNameInput = document.getElementById('billing_last_name');

                            if (billingFirstNameInput) {
                                billingFirstNameInput.value = firstName || '';
                                dispatchChangeEvent(billingFirstNameInput);
                            }
                            if (billingLastNameInput) {
                                billingLastNameInput.value = lastName || '';
                                dispatchChangeEvent(billingLastNameInput);
                            }
                        });
                    }

                    // Event listener for user_phone input changes
                    const userPhoneInput = document.getElementById('user_phone');
                    if (userPhoneInput) {
                        userPhoneInput.addEventListener('input', (e) => {
                            const billingPhoneInput = document.getElementById('billing_phone');
                            if (billingPhoneInput) { billingPhoneInput.value = e.target.value || ''; dispatchChangeEvent(billingPhoneInput); }
                        });
                    }

                    document.dispatchEvent(new CustomEvent('kpCheckoutCompaniesLoaded', { detail: { companies } }));
                }
            })
            .catch(error => console.error('Error:', error));
    }
    _load_user_data();
    initNovaPoshtaAutofill();
});


function initNovaPoshtaAutofill() {
    const novaAddressSelect = document.getElementById('selected_address_nova');
    const novaAddressGroup = document.getElementById('nova-select-other-address');
    const companyNpGroup = document.getElementById('company-np-addresses');
    const companyNpSelect = document.getElementById('selected_company_address_nova');
    let savedAddressesData = [];

    /** Блок збережених адрес НП у шаблоні (якщо немає — не виходимо з функції: блок юрособи все одно треба) */
    const hasNovaSavedAddressesUi = Boolean(novaAddressSelect && novaAddressGroup);

    if (typeof main !== 'undefined' && main.checkoutCompanies && Array.isArray(main.checkoutCompanies)) {
        window.kpCheckoutCompanies = main.checkoutCompanies;
    }

    if (hasNovaSavedAddressesUi) {
        novaAddressGroup.style.display = 'none';
    }
    if (companyNpGroup) {
        companyNpGroup.style.display = 'none';
    }

    function populateCompanyNpSelect() {
        if (!companyNpSelect) {
            return;
        }
        const companies = window.kpCheckoutCompanies || [];
        const le = document.getElementById('legal_entity');
        const companyId = le ? le.value : '';
        const selectedCompany = companies.find(c => String(c.id) === String(companyId));
        const firstOpt = companyNpSelect.querySelector('option[value=""]');
        const placeholder = firstOpt ? firstOpt.textContent : 'Оберіть адресу з юридичної особи';
        companyNpSelect.innerHTML = '';
        const opt0 = document.createElement('option');
        opt0.value = '';
        opt0.textContent = placeholder;
        companyNpSelect.appendChild(opt0);
        if (selectedCompany && Array.isArray(selectedCompany.addresses)) {
            selectedCompany.addresses.forEach(addr => {
                const t = addr != null ? String(addr).trim() : '';
                if (!t) {
                    return;
                }
                const o = document.createElement('option');
                o.value = t;
                o.textContent = t;
                companyNpSelect.appendChild(o);
            });
        }
    }

    function syncNovaAddressBlocksVisibility() {
        let sm = document.querySelector('input[name^="shipping_method"]:checked');
        if (!sm) {
            sm = document.querySelector('input[name^="shipping_method"][type="hidden"]');
        }
        const checked = sm ? String(sm.value) : '';
        const isNpTtn = checked.indexOf('kitan_np_ttn') !== -1;
        const isMrkvNp = checked.indexOf('mrkv_ua_shipping_nova-poshta') !== -1;
        // «Оберіть адресу доставки» (збережені адреси) — не показувати для «НП по ТТН».
        if (novaAddressGroup) {
            if (isNpTtn) {
                novaAddressGroup.style.display = 'none';
            } else if (hasNovaSavedAddressesUi) {
                novaAddressGroup.style.display = (isMrkvNp && savedAddressesData.length > 0) ? '' : 'none';
            } else {
                novaAddressGroup.style.display = '';
            }
        }
        // Company (BAS) NP addresses block is disabled in theme until feature is ready.
        if (companyNpGroup) {
            companyNpGroup.style.display = 'none';
        }
    }

    window.kpSyncNovaAddressBlocks = syncNovaAddressBlocksVisibility;

    function fetchNovaPoshtaAddresses() {
        const formData = new FormData();
        formData.append('action', 'kp_get_nova_poshta_addresses');
        formData.append('nonce', main.nonce);

        fetch(main.ajaxUrl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(response => {
                if (response.success && Array.isArray(response.data) && response.data.length > 0) {
                    console.info(response.data);
                    savedAddressesData = response.data;
                    populateNovaPoshtaSelect(savedAddressesData);
                } else {
                    savedAddressesData = [];
                }
                syncNovaAddressBlocksVisibility();
            })
            .catch(error => {
                console.error("Error fetching Nova Poshta addresses:", error);
                syncNovaAddressBlocksVisibility();
            });
    }

    function populateNovaPoshtaSelect(addresses) {
        if (!hasNovaSavedAddressesUi) {
            return;
        }
        const defaultOption = novaAddressSelect.querySelector('option[value=""]');
        const defaultOptionText = defaultOption ? defaultOption.textContent : 'Оберіть адресу доставки замовлення';
        novaAddressSelect.innerHTML = `<option value="">${defaultOptionText}</option>`;
        addresses.forEach((address, index) => {
            if (address.short_name) {
                const option = document.createElement('option');
                option.value = index;
                option.textContent = address.short_name;
                novaAddressSelect.appendChild(option);
            }
        });
    }

    if (hasNovaSavedAddressesUi) {
    novaAddressSelect.addEventListener('change', async function () {
        const selectedIndex = this.value;
        if (selectedIndex === '' || !savedAddressesData[selectedIndex]) {
            return;
        }

        const selectedAddress = savedAddressesData[selectedIndex];
        const $ = window.jQuery;

        const npMethodFamily = (id) => {
            const s = String(id || '');
            if (s.indexOf('poshtamat') !== -1) {
                return 'poshtamat';
            }
            if (s.indexOf('address') !== -1) {
                return 'address';
            }
            if (s.indexOf('mrkv_ua_shipping_nova-poshta') !== -1) {
                return 'warehouse';
            }
            return '';
        };

        const selectHasValue = ($field, value) => {
            return $field.find('option').filter(function () {
                return this.value === value;
            }).length > 0;
        };

        const meaningfulOptionCount = (field) => {
            if (!field || field.tagName !== 'SELECT') {
                return 0;
            }
            return Array.from(field.options).filter((opt) => String(opt.value || '') !== '').length;
        };

        // Set field value and fire change. Create a missing <option> only when allowed
        // (city may be absent from the popular-cities list; warehouse/street should wait for plugin options).
        const setFieldAndTriggerChange = (fieldName, value, allowCreate) => {
            const $field = $(`[name="${fieldName}"]`).first();
            if (!$field.length || value === undefined || value === null || value === '') {
                return;
            }
            if ($field.is('select')) {
                if (!selectHasValue($field, value) && allowCreate) {
                    const text = selectedAddress[fieldName + '_text'] || value;
                    $field.append(new Option(text, value, true, true));
                }
                if (!selectHasValue($field, value)) {
                    return;
                }
            }
            $field.val(value).trigger('change');
        };

        // Wait until the select has real options (placeholder-only does not count).
        const waitForOptions = (selector, wantedValue) => {
            return new Promise((resolve) => {
                const ready = () => {
                    const field = document.querySelector(selector);
                    if (!field || field.tagName !== 'SELECT') {
                        return true;
                    }
                    if (wantedValue && selectHasValue($(field), wantedValue)) {
                        return true;
                    }
                    return meaningfulOptionCount(field) > 0;
                };

                if (ready()) {
                    resolve();
                    return;
                }

                const field = document.querySelector(selector);
                const observer = new MutationObserver(() => {
                    if (ready()) {
                        observer.disconnect();
                        setTimeout(resolve, 150);
                    }
                });

                if (field) {
                    observer.observe(field, { childList: true });
                }

                setTimeout(() => {
                    observer.disconnect();
                    resolve();
                }, 4000);
            });
        };

        const waitForCheckoutUpdate = () => {
            return new Promise((resolve) => {
                let done = false;
                const finish = () => {
                    if (done) {
                        return;
                    }
                    done = true;
                    setTimeout(resolve, 150);
                };
                $(document.body).one('updated_checkout', finish);
                setTimeout(finish, 4000);
            });
        };

        // 1. Switch shipping method (exact instance, then same NP family).
        const savedMethodId = String(selectedAddress.shipping_method_id_with_instance || '');
        const $methodRadios = $('input[name="shipping_method[0]"]');
        let $method = $methodRadios.filter(`[value="${savedMethodId}"]`);
        if (!$method.length && savedMethodId) {
            const family = npMethodFamily(savedMethodId);
            if (family) {
                $method = $methodRadios.filter(function () {
                    return npMethodFamily(this.value) === family;
                });
            }
        }
        // Prefer the native WooCommerce radio, not the cloned custom list.
        const $originalMethod = $method.filter(function () {
            return $(this).closest('#custom-shipping-methods').length === 0;
        });
        const $methodTarget = $originalMethod.length ? $originalMethod.first() : $method.first();
        if ($methodTarget.length && !$methodTarget.is(':checked')) {
            $methodTarget.prop('checked', true).trigger('change');
            await waitForCheckoutUpdate();
        }

        const allFields = Object.keys(selectedAddress);
        const shippingMethodId = savedMethodId;
        const isPoshtamat = shippingMethodId.includes('poshtamat');
        const isAddress = shippingMethodId.includes('address');

        let cityField;
        let warehouseField;
        let streetField;
        let flatField;

        if (isPoshtamat) {
            cityField = allFields.find((f) => f.endsWith('_poshtamat_city'));
            warehouseField = allFields.find((f) => f.endsWith('_poshtamat_name'));
        } else if (isAddress) {
            cityField = allFields.find((f) => f.endsWith('_address_city'));
            streetField = allFields.find((f) => f.endsWith('_address_street'));
            flatField = allFields.find((f) => f.endsWith('_address_flat'));
        } else {
            cityField = allFields.find((f) => f.endsWith('nova-poshta_city'));
            warehouseField = allFields.find((f) => f.endsWith('_warehouse'));
        }

        // 2. Set city (create option if missing), then wait for warehouse/street lists.
        if (cityField && selectedAddress[cityField]) {
            setFieldAndTriggerChange(cityField, selectedAddress[cityField], true);

            if (warehouseField) {
                await waitForOptions(`[name="${warehouseField}"]`, selectedAddress[warehouseField]);
            }
            if (streetField) {
                await waitForOptions(`[name="${streetField}"]`, selectedAddress[streetField]);
            }
        }

        // 3. Remaining fields. Create a missing option only as last resort after wait.
        for (const key in selectedAddress) {
            if (key === cityField || key === flatField || key === 'shipping_method_id_with_instance' || key.endsWith('_text') || key === 'short_name') {
                continue;
            }
            const allowCreate = key === warehouseField || key === streetField || key.endsWith('_house');
            setFieldAndTriggerChange(key, selectedAddress[key], allowCreate);
        }

        // 4. Flat last so a house `change` does not clear it.
        if (flatField && selectedAddress[flatField]) {
            setFieldAndTriggerChange(flatField, selectedAddress[flatField], true);
        }
    });
    }

    if (hasNovaSavedAddressesUi && document.body.classList.contains('logged-in')) {
        fetchNovaPoshtaAddresses();
    } else {
        syncNovaAddressBlocksVisibility();
    }

    document.addEventListener('kpCheckoutCompaniesLoaded', () => {
        populateCompanyNpSelect();
        syncNovaAddressBlocksVisibility();
    });

    const legalEntityForNp = document.getElementById('legal_entity');
    if (legalEntityForNp) {
        legalEntityForNp.addEventListener('change', () => {
            populateCompanyNpSelect();
            if (companyNpSelect) {
                companyNpSelect.value = '';
            }
            syncNovaAddressBlocksVisibility();
        });
    }

    window.jQuery(document.body).on('updated_checkout', function () {
        syncNovaAddressBlocksVisibility();
    });

    populateCompanyNpSelect();
    syncNovaAddressBlocksVisibility();
}


function fix_hidden_parent_blocks() {
    const fields = document.querySelectorAll('.woocommerce-checkout__content .form-row');
    fields.forEach(container => {
        const hidden_fields = container.querySelectorAll('.input-hidden');
        if (hidden_fields.length > 0) {
            container.style.display = "none";
            container.classList.add('row-hidden');
        } else {
            container.classList.remove('row-hidden');
            container.style.display = "block";
        }

    });
}

function toggleLocalBlocks() {
    const localBlocks = document.querySelectorAll('.woocommerce-checkout__content  .only-locals');

    if (localBlocks.length === 0) return;

    let isLocal = false;

    let selectedMethod = document.querySelector('input[name^="shipping_method"]:checked');
    if (!selectedMethod) {
        selectedMethod = document.querySelector('input[name^="shipping_method"][type="hidden"]');
    }

    if (selectedMethod) {
        const val = selectedMethod.value;
        let text = '';
        const parentLi = selectedMethod.closest('li');
        if (parentLi) {
            text = parentLi.innerText.toLowerCase();
        }

        if (val.includes('free_shipping') && (text.includes('київ') || text.includes('киев'))) {
            isLocal = true;
        }
    }

    localBlocks.forEach(block => {
        block.style.display = isLocal ? '' : 'none';
    });
}

function toggleRecipientFieldsBlock() {
    const recipientBlock = document.getElementById('edit-recipient-field');
    if (!recipientBlock) return;

    let showRecipient = false;
    let selectedMethod = document.querySelector('input[name^="shipping_method"]:checked');
    if (!selectedMethod) {
        selectedMethod = document.querySelector('input[name^="shipping_method"][type="hidden"]');
    }

    if (selectedMethod) {
        const val = selectedMethod.value;
        let text = '';
        const parentLi = selectedMethod.closest('li');
        if (parentLi) {
            text = parentLi.innerText.toLowerCase();
        }
        const isNpTtn = val.includes('kitan_np_ttn');
        const isPickup = val.includes('local_pickup');
        const isMrkvNp = val.includes('mrkv_ua_shipping_nova-poshta');
        // «НП по ТТН» — без блоку отримувача (лише ТТН).
        showRecipient = !isNpTtn && (isPickup || isMrkvNp);
    }

    recipientBlock.style.display = showRecipient ? '' : 'none';
}

function reorderCustomShippingMethodsBySource($container, $source) {
    if (!$container || !$container.length || !$source || !$source.length) return;

    const sourceOrder = {};
    $source.children('li').each(function (idx) {
        const key = String(jQuery(this).find('input[name^="shipping_method"]').val() || '');
        if (key && sourceOrder[key] === undefined) {
            sourceOrder[key] = idx;
        }
    });

    const getForcedGroup = (key) => {
        const methodId = key.includes(':') ? key.split(':')[0] : key;

        // 1) All Nova Poshta methods first.
        if (methodId.startsWith('mrkv_ua_shipping_nova-poshta')) {
            return 1;
        }
        // 2) NP by TTN second.
        if (methodId === 'kitan_np_ttn') {
            return 2;
        }
        // 3) All remaining methods after.
        return 3;
    };

    const sortedNodes = $container.children('li').get().map((node, idx) => {
        const key = String(jQuery(node).find('input[name^="shipping_method"]').val() || '');
        const group = getForcedGroup(key);
        const order = sourceOrder[key] !== undefined ? sourceOrder[key] : idx;

        return { node, idx, group, order };
    }).sort((a, b) => {
        if (a.group === b.group) {
            return a.order === b.order ? a.idx - b.idx : a.order - b.order;
        }
        return a.group - b.group;
    })
      .map(x => x.node);

    $container.append(sortedNodes);
}

jQuery(function ($) {
    // When the checkout is updated, copy the shipping methods
    $(document.body).on('updated_checkout', function () {
        const $cshm = $('#custom-shipping-methods');
        const $shipping_methods = $('#order_review .woocommerce-shipping-methods');

        // Replace the content of your custom shipping container
        if ($shipping_methods.html()) {
            $cshm.html($shipping_methods.html());
            reorderCustomShippingMethodsBySource($cshm, $shipping_methods);
            $cshm.find('li')?.addClass('radio');
            $cshm.find('input[type="radio"]')?.addClass('radio__input');
            const $labels = $cshm.find('label');
            if ($labels) {
                $labels.addClass('radio__wrap');
                $labels.each(function () {
                    const text = $(this).text();
                    $(this).html(`<div class="radio__content"><span>${text}</span></div>`);
                });
            }

        } else {
            $cshm.html('');
        }
        toggleLocalBlocks();
        toggleRecipientFieldsBlock();
        if (typeof window.kpSyncNovaAddressBlocks === 'function') {
            window.kpSyncNovaAddressBlocks();
        }
    });

    $(document.body).on('change', 'input[name^="shipping_method"]', function () {
        toggleLocalBlocks();
        toggleRecipientFieldsBlock();
        if (typeof window.kpSyncNovaAddressBlocks === 'function') {
            window.kpSyncNovaAddressBlocks();
        }
    });

    fix_hidden_parent_blocks();
    toggleLocalBlocks();
    toggleRecipientFieldsBlock();
    setTimeout(function () {
        if (typeof window.kpSyncNovaAddressBlocks === 'function') {
            window.kpSyncNovaAddressBlocks();
        }
    }, 0);
});

// New function to update billing address fields and dispatch change events
function updateBillingAddressFields(parsedAddress) {
    const billingCityInput = document.getElementById('billing_city');
    const billingStateInput = document.getElementById('billing_state');
    const billingPostcodeInput = document.getElementById('billing_postcode');
    const billingAddress1Input = document.getElementById('billing_address_1');
    const billingCountryInput = document.getElementById('billing_country');

    if (billingCityInput) billingCityInput.value = parsedAddress.city;
    if (billingStateInput) setSelectOptionByText(billingStateInput, parsedAddress.state);
    if (billingPostcodeInput) billingPostcodeInput.value = parsedAddress.postcode;
    if (billingAddress1Input) billingAddress1Input.value = parsedAddress.address1;
    if (billingCountryInput) billingCountryInput.value = 'UA'; // Always set to Ukraine

    dispatchChangeEvent(billingCityInput);
    dispatchChangeEvent(billingStateInput);
    dispatchChangeEvent(billingPostcodeInput);
    dispatchChangeEvent(billingAddress1Input);
    dispatchChangeEvent(billingCountryInput);
}
